var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "fixed flex justify-end w-screen transition-all duration-500 top-18",
      style: {
        right: _vm.open ? "0vw" : "-100vw",
        height: "calc(100vh - 4.5rem - 3.5rem)",
        zIndex: 52
      },
      attrs: { id: "instruction-comment-panel" }
    },
    [
      _c("div", {
        staticClass: "absolute top-0 left-0 w-screen h-full -z-10",
        on: {
          click: function($event) {
            return _vm.$emit("close-panel")
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "relative z-0 flex flex-col flex-shrink-0 h-full w-120"
        },
        [
          _c("div", [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between px-6 h-18 bg-pure-white"
              },
              [
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cursor-pointer",
                        on: {
                          click: function($event) {
                            return _vm.$emit("close-panel")
                          }
                        }
                      },
                      [
                        _vm.open
                          ? _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "arrow-left", color: "slate-6" }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextTitle4", { attrs: { text: "Comment" } })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "cursor-pointer",
                    on: {
                      click: function($event) {
                        return _vm.$emit("close-panel")
                      }
                    }
                  },
                  [
                    _vm.open
                      ? _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "close", color: "slate-6" }
                        })
                      : _vm._e()
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "px-3 bg-pure-white" }, [
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-col gap-1 p-3 border rounded bg-slate-200 border-slate-300"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex items-center justify-between truncate cursor-pointer",
                      attrs: { title: _vm.instruction.title },
                      on: {
                        click: function($event) {
                          _vm.chevronOpened = !_vm.chevronOpened
                        }
                      }
                    },
                    [
                      _c("BlTextSubtitle3", {
                        staticClass: "truncate",
                        attrs: { text: _vm.instruction.title }
                      }),
                      _vm._v(" "),
                      _vm.open
                        ? _c("BlIcon", {
                            staticClass: "w-4 h-4 transition-all duration-300",
                            style: {
                              rotate: _vm.chevronOpened ? "180deg" : ""
                            },
                            attrs: { icon: "chevron-down" }
                          })
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c("div", {
                      staticClass: "text-sm whitespace-pre-line text-slate-700",
                      class: { "line-clamp-1": !_vm.chevronOpened },
                      domProps: {
                        innerHTML: _vm._s(_vm.instruction.description)
                      }
                    })
                  ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative flex flex-col justify-between h-full overflow-y-auto bg-pure-white"
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-col gap-1 px-3 py-5" },
                [
                  !_vm.instruction.comments.length
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "grid items-center justify-center h-64 text-center"
                        },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "No comments yet. Be the first to share your thoughts on this instruction."
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.instruction.comments, function(comment) {
                    return _c("InstructionCommentItem", {
                      key: comment.id,
                      attrs: { comment: comment },
                      on: {
                        "toggle-edit-state": function($event) {
                          _vm.editState = $event
                        }
                      }
                    })
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "sticky bottom-0 z-0 flex-shrink-0 px-4 py-4 transition-all duration-300 bg-pure-white",
              class: [
                _vm.editState
                  ? "h-16 opacity-25 overflow-hidden"
                  : "h-48 opacity-100"
              ]
            },
            [
              _vm.open
                ? _c(
                    "div",
                    { staticClass: "relative pb-px" },
                    [
                      _c("BlInputButton", {
                        staticClass: "absolute top-2 right-2",
                        attrs: {
                          icon: "paper-plane",
                          dense: "",
                          disabled: _vm.isDisabledSubmit,
                          loading: _vm.submitLoading
                        },
                        on: { clicked: _vm.onCreate }
                      }),
                      _vm._v(" "),
                      _c("VueEditor", {
                        staticClass: "blum-editor",
                        attrs: {
                          "editor-toolbar": _vm.customToolbar,
                          placeholder: "Comment this instruction"
                        },
                        model: {
                          value: _vm.bodyInput,
                          callback: function($$v) {
                            _vm.bodyInput = $$v
                          },
                          expression: "bodyInput"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-214b9d2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-214b9d2f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/prospectPanel/CommentPanel.vue
// module id = null
// module chunks = 